module.exports = __webpack_public_path__ + "static/media/t_fr.b21d32da.pdf";